import React, { FunctionComponent } from "react";

const CalendarInformationIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/interface-essential/date-calendar/calendar-information
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.25 -0.25 24.5 24.5">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.25 23.25C20.5637 23.25 23.25 20.5637 23.25 17.25C23.25 13.9363 20.5637 11.25 17.25 11.25C13.9363 11.25 11.25 13.9363 11.25 17.25C11.25 20.5637 13.9363 23.25 17.25 23.25Z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.25 20.25V17.25"
      ></path>
      <path
        stroke="currentColor"
        d="M17.25 15C17.0429 15 16.875 14.8321 16.875 14.625C16.875 14.4179 17.0429 14.25 17.25 14.25"
      ></path>
      <path
        stroke="currentColor"
        d="M17.25 15C17.4571 15 17.625 14.8321 17.625 14.625C17.625 14.4179 17.4571 14.25 17.25 14.25"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.25 17.25H2.25C1.85218 17.25 1.47064 17.092 1.18934 16.8107C0.908035 16.5294 0.75 16.1478 0.75 15.75V3.765C0.75 3.36717 0.908035 2.98564 1.18934 2.70434C1.47064 2.42303 1.85218 2.265 2.25 2.265H15.75C16.1478 2.265 16.5294 2.42303 16.8107 2.70434C17.092 2.98564 17.25 3.36717 17.25 3.765V8.25"
      ></path>
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M0.75 6.75H17.25"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.24292 3.75V0.75"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.7429 3.75V0.75"
      ></path>
    </svg>
  );
};

export default CalendarInformationIcon;
